export const state = {
  addTemplate: {
    title: '',
    message: ''
  },
  updateTemplate: {},
  template: {},
  templates: [],
  total: 0,
  selectedTemplateList: []
}
export const mutations = {
  setTemplates(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      if (
        state.selectedTemplateList.some(
          selectedTemplate =>
            selectedTemplate.id === response.data['data'][i]['id']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
    }
    state.templates = response.data['data']
    state.total = response.data['header']['total']
  },
  setDetail(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = ''
    }
    state.template = response.data['data']
    state.updateTemplate = {}
    state.updateTemplate.id = state.template.id
    state.updateTemplate.title = state.template.title
    state.updateTemplate.message = state.template.message
  },
  inputUpdate(state, payload) {
    state.updateTemplate[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addTemplate[payload.name] = payload.value
  },
  clearTemplate(state) {
    state.addTemplate = {}
  },
  updateSelectedTemplateList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedTemplateList.some(
          template => template.id === payload[i].id
        )
      ) {
        state.selectedTemplateList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedTemplateList.some(
          template => template.id === payload[i].id
        )
      ) {
        const deleteIndex = state.selectedTemplateList.findIndex(
          template => template.id === payload[i].id
        )
        state.selectedTemplateList = state.selectedTemplateList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedTemplateList(state) {
    state.selectedTemplateList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/templateModules/templateMutation.js